export default "__VITE_ASSET__B6XF3O4F__"